export default __webpack_public_path__ + "static/media/hair.d5704a77.ogg";